const toggleMap = (toggleElement: HTMLELement, goBackLabel, zoomToBounds): void => {
  const mapArea: HTMLElement = document.querySelector(toggleElement.dataset.mapTarget);
  const hideWhenOpen: HTMLElement = document.querySelector(toggleElement.dataset.hideWhenOpen);
  let toggleActive = false;

  toggleElement.addEventListener('click', () => {
    if (!toggleActive) {
      mapArea.style.display = 'block';
      if (hideWhenOpen != null) {
        hideWhenOpen.style.display = 'none';
      }
      toggleElement.innerHTML = goBackLabel;
      zoomToBounds();
    } else {
      mapArea.style.display = 'none';
      if (hideWhenOpen != null) {
        hideWhenOpen.style.display = 'grid';
      }
      toggleElement.innerHTML = 'Map View';
    }
    toggleActive = !toggleActive;
  });
};

export default toggleMap;
